import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import OrderModal from './OrderModal';
import { notification, Table, Select, Button, Input, InputNumber, Popconfirm, Tooltip  } from 'antd';
import { COMPANY_TYPE } from 'constant';

@inject(({ orderStore }) => ({ 
  cartList: orderStore.cartList,
  disCartList: orderStore.disCartList,
  merCartInfo: orderStore.merCartInfo,
  delCartInfo: orderStore.delCartInfo,

  modalOpenCart: orderStore.modalOpenCart,
  onModalCart: orderStore.onModalCart,

  valCondition: orderStore.valCondition,
  disLastOrder: orderStore.disLastOrder,
}))
@observer
class CartList extends Component {
  state = {
    cartList: [],

    editingKey: null,
    editData: {}
  };

  UNSAFE_componentWillMount() {
    this.props.disCartList();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.cartList !== this.props.cartList) {
      this.setState({ cartList: nextProps.cartList});
    }

    if (nextProps.valCondition.selectCeCd !== this.props.valCondition.selectCeCd) {
      this.props.disCartList();
    }
  }

  handleOrder = () => {
    if (this.props.cartList.length <= 0) {
      notification.warning({placement: 'bottomLeft', message: `장바구니가 비어있습니다.`, duration: 2});
      return;
    }
    this.props.disLastOrder();
    this.setState({ editingKey: null, editData: {}});
    this.props.onModalCart(true);
  };



  handleChange = (type, name, item, record, index) => {
    const { editData } = this.state;
    const funcChange = (valuNm, value, option) => {
      if (type === 'Select') {
        this.setState({
          editData:{
            ...editData,
            [valuNm]:value,
            stCnt: option,
          }
        });
      } else {
        this.setState({
          editData:{
            ...editData,
            [valuNm]:value,
          }
        });
      }
    };
    
    if (type === 'Input') {
      return (
        <Input
          value={editData[name]}
          onChange={(e)=>funcChange(name, e.target.value)}
          style={{ width: '100%' }}
        />
      )
    } else if (type === 'InputNumber') {
      return (
        <Fragment>
          <InputNumber
            value={editData[name]}
            min={1}
            onChange={(value)=>funcChange(name, value)}
            style={{ width: '100%' }}
          />
        </Fragment>
      )
    }else if (type === 'Select') {
      return (
        <Fragment>
          <Select
            style={{ width: '100%' }}
            value={editData[name]}
            onChange={(value, option)=>funcChange(name, value, option.option.stCnt)}
          >
            {record.gdSizeList !== undefined && record.gdSizeList !== null &&
              record.gdSizeList.map(option=>{
              return(
                <Select.Option
                  disabled={option.stCnt === 0 ? true : false}
                  key={option.stSize}
                  option={option}
                >{option.stSize} 재고:{option.stCnt}</Select.Option>
              )
            })}
          </Select>
          {editData[name] === "기타" &&
          <Input
            placeholder={process.env.REACT_APP_ETCSIZE}
            value={editData.caEtc}
            onChange={(e)=>funcChange("caEtc", e.target.value)}
            style={{ width: '100%', marginTop: '5px' }}
          />
          }
        </Fragment>
      )
    }
  };

  save = async () => {
    const { editData } = this.state;
    // console.log("editData : ", editData);

    if (parseInt(editData.stCnt) < parseInt(editData.caCnt)) {
      notification.warning({placement: 'bottomLeft', message: `구매가능 수량&재고(${parseInt(editData.stCnt)})을 초과하였습니다.`, duration: 2});
      return false;
    }
    

    if (editData.caGdSize === '기타' && editData.caEtc === '') {
      notification.warning({placement: 'bottomLeft', message: process.env.REACT_APP_ETCSIZE, duration: 2});
      return false;
    }

    this.props.merCartInfo(this.state.editData);
    this.setState({ editingKey: null, editData: {}});
  };

  render() {
    const { delCartInfo, modalOpenCart, onModalCart, valCondition, ceType, cGbn } = this.props;
    const { cartList, editingKey } = this.state;
    const isEditing = record => record.RNUM === editingKey;
    const columns = [
      { title: 'No', dataIndex: 'RNUM', width: 70, align: 'center' },
      // { title: text_companyNm(), dataIndex: 'caCeNm', width: 180, align: 'center' },
      // { title: '담당자', dataIndex: 'userNm', width: 150, align: 'center' },
      { title: '상품명', dataIndex: 'gdNm', align: 'center' },
      { title: '사원명', dataIndex: 'dresserNm', width: 130, align: 'center',
        render: (item, record, index) => {
          const editable = isEditing(record);
          return editable ? (
            this.handleChange('Input', 'dresserNm', item, record, index)
            ) : (
            item
        )},
        editable: true
      },
      { title: '사이즈', dataIndex: 'caGdSize', width: 200, align: 'center',
        render: (item, record, index) => { 
          const editable = isEditing(record);
          return editable ? (
            this.handleChange('Select', 'caGdSize', item, record, index)
          ) : (
            item === "기타"
            ? <Tooltip placement="topLeft" title={record.caEtc}>
                <span style={{color: 'blue'}}>{item}</span>
              </Tooltip>
            : item
          )
        },
        editable: true
      },
      { title: '주문수량', dataIndex: 'caCnt', width: 100, align: 'center',
        render: (item, record, index) => {
          const editable = isEditing(record);
          return editable ? (
            this.handleChange('InputNumber', 'caCnt', item, record, index)
            ) : (
            item
        )},
        editable: true
      },
      { title: '금액', dataIndex: 'gdPrice', width: 150, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item !== undefined && item !== null && item !== '' &&
            (parseInt(item)*parseInt(record.caCnt)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </Fragment>
        )}
      },
      { title: '수정/삭제', dataIndex: '', key: 'edit', width: 220, align: 'center',
        render: (item, record, index) => {
          const editable = isEditing(record);
          return editable ? (
            <Fragment>
              <Button
                onClick={() => this.save()}
                style={{ marginRight: 8 }}
              >저장</Button>
              <Button
                onClick={() =>{
                  this.setState({editingKey: null});
                  this.setState({cartList: this.props.cartList})
                }}
              >취소</Button>
            </Fragment>
          ) : (
            <Fragment>
              <Button
                disabled={editingKey !== null}
                style={{ marginRight: 8 }}
                onClick={() => this.setState({
                  editingKey: record.RNUM,
                  editData: {
                    ...record,
                    caGdSizeOrg: record.caGdSize,
                    caCutOrg: record.caCnt
                  }
                })}
              >수정</Button>
              &nbsp;&nbsp;
              <Popconfirm 
                title="삭제하시겠습니까?"
                onConfirm={() => {
                  delCartInfo(record.caNo);
                }}
                onClick={(e)=>e.stopPropagation()}
              >
                <Button
                  disabled={editingKey !== null}
                >삭제</Button>
              </Popconfirm>
            </Fragment>
          );
        }
      },
    ];

    const totalMoney = () => {
      let total = 0;
      this.state.cartList.map(item=>{
        return(total = total + parseInt(item.gdPrice)*parseInt(item.caCnt))
      });
      return (
        <Fragment>{total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Fragment>
      );
    };
    return (
      <Fragment>
        <div className="button-group">
          <h2>▶ 장바구니 {valCondition.exceptionYn === "Y" && <span style={{ color: 'blue' }}>(기준외주문)</span>}</h2>
          <h4 style={{ color: 'red' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ※장바구니는 새벽 3시에 초기화됩니다.
          </h4>
          <div className="button-right">
            <ul>
              <li>
              <div className="cart_total" >
                ▶ 총액 : &nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{ color: 'red' }}> 
                  {totalMoney()}
                </span>
                &nbsp;&nbsp;&nbsp; 원
                <Button
                  className="buttonR"
                  type="primary"
                  onClick={this.handleOrder}
                >주문하기</Button>
              </div>
              </li>
              <li>
                
              </li>
            </ul>
          </div>
        </div>

        <Table
          rowKey={(record)=>record.RNUM}
          dataSource={cartList}
          columns={(cGbn === COMPANY_TYPE.KNP) 
            ? columns.filter(item=> item?.dataIndex !== 'dresserNm')
            : columns
          }
          rowClassName="editable-row"
          pagination={false}
          scroll={{ y: 400 }}
        />

        <OrderModal
          ceType={ceType}
          cGbn={cGbn}
          modalOpen={modalOpenCart}
          modalClose={()=>onModalCart(false)}
          cartList={this.state.cartList}
        />
      </Fragment>
    );
  }

}

export default withRouter(CartList);
